import React, { Component } from 'react';
import { Button } from 'antd';

import localDb from '@util/localDb';
import { BackBtn } from '@comm/BackBtn';
import ModalReject from './ModalReject';

export default WrappedComponent => {
  return class WorkflowOp extends Component {
    constructor(props) {
      super(props);
      this.state = {
        rejectVisible: false,
      };
    }

    componentWillMount() {
      this.userUuid = localDb.get('userUuid');
    }

    handleRejectVisible = flag => {
      this.setState({
        rejectVisible: !!flag,
      });
    };

    // 通过按钮，不同流程有不同的特殊操作
    handleNext = () => {
      this.props.doTask('next');
    };

    // 判断流程中的用户是否有收回按钮
    isAuditor = (activities, currentUser) => {
      return activities.some((item, index) => {
        return (
          (this.userUuid === item.processor || item.processor.indexOf(this.userUuid) !== -1) &&
          activities[index + 1] &&
          currentUser &&
          currentUser.uuid === activities[index + 1].uuid
        );
      });
    };

    handleReturn = params => {
      this.props.doTask('return', params);
      this.handleRejectVisible(false);
    };

    changeButton = () => {
      const { data, doTask } = this.props;
      const { instance = {} } = data;
      const { preActivity = {}, activities = [], currentActivity: currentUser = {} } = instance;

      // 报销status:(0,流程进行中；1,流程结束；2.废弃)
      // activities:status:(0,未开始；1,正在进行；2.结束)

      // 审核开关(会签情况)
      const examineFlag =
        currentUser &&
        currentUser.messages &&
        currentUser.messages.some(item => {
          return item.processor === this.userUuid && item.isDone === 0 && item.status === 0;
        });

      // 当前会签环节是否有收回
      const callbackFlag =
        currentUser &&
        currentUser.messages &&
        currentUser.messages.some(item => {
          return item.processor === this.userUuid && item.isDone === 1 && item.status === 0;
        });

      if (instance.status !== 0) {
        return null;
      }
      if (
        (currentUser && currentUser.processor && currentUser.processor === this.userUuid) ||
        examineFlag
      ) {
        // 当前流程审核人打开
        return (
          <span>
            <Button
              icon="arrow-left"
              style={{ marginRight: 10 }}
              onClick={() => this.handleRejectVisible(true)}
            >
              退回
            </Button>
            <WrappedComponent {...this.props} />
            {(preActivity && preActivity.processor === this.userUuid) ||
            (data.createUser === this.userUuid && activities[0] && activities[0].status !== 2) ? (
              <Button
                icon="arrow-left"
                style={{ marginRight: 10 }}
                onClick={() => doTask('callback')}
              >
                收回
              </Button>
            ) : null}
          </span>
        );
      }
      if (
        (data.createUser === this.userUuid && activities[0] && activities[0].status !== 2) ||
        this.isAuditor(activities, currentUser) ||
        callbackFlag
      ) {
        // 申请人打开
        return (
          <span>
            <Button
              icon="arrow-left"
              style={{ marginRight: 10 }}
              onClick={() => doTask('callback')}
            >
              收回
            </Button>
          </span>
        );
      }
      return null;
    };

    render() {
      const { rejectVisible } = this.state;
      return (
        <div className="form-open">
          <div style={{ marginBottom: '16px' }}>
            <BackBtn />
            {this.changeButton()}
          </div>
          <ModalReject
            visible={rejectVisible}
            handleOk={this.handleReturn}
            handleCancel={this.handleRejectVisible}
          />
        </div>
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/components/comm/workflow/HOCWorkflow.js